import { jsxs as d, Fragment as g, jsx as s } from "react/jsx-runtime";
import { TextInputFormik as p } from "@strata/react-inputs";
import * as a from "yup";
import { SuggestSingleSelectFormik as h } from "@strata/react-selects";
import { validationStrings as c } from "@strata/strata-ui-strings";
import { useFormikContext as f, getIn as V } from "formik";
import { useMemo as q } from "react";
const t = "Other", o = (e) => `${e}${t}`, i = ({
  id: e,
  label: r,
  required: n = void 0,
  values: m = void 0
}) => {
  const l = f(), v = q(() => [...m ?? [], t], [m]);
  return /* @__PURE__ */ d(g, { children: [
    /* @__PURE__ */ s(
      h,
      {
        id: e,
        label: r,
        required: n,
        verticalSpacingSmall: !0,
        values: v,
        onChange: (S) => {
          (async () => await l.setValues({
            ...l.values,
            [e]: S,
            [o(e)]: void 0
          }))();
        }
      }
    ),
    V(l.values, e) === t && /* @__PURE__ */ s(
      p,
      {
        id: o(e),
        label: `Other ${r}`,
        required: !0,
        verticalSpacingSmall: !0
      }
    )
  ] });
};
i.initialValues = ({
  id: e
}) => ({
  [e]: void 0,
  [o(e)]: void 0
});
i.validationSchema = ({
  id: e,
  required: r
}) => ({
  [e]: r ? a.string().required(c.requiredField.errorMessage) : a.string(),
  [o(e)]: a.string().when(e, {
    is: t,
    then: (n) => n.required(c.requiredField.errorMessage)
  })
});
i.submitValues = ({ id: e }) => (r) => ({
  [e]: r[e] === t ? r[o(e)] : r[e]
});
const u = ({ reasons: e = void 0, hideSource: r = !1 }) => /* @__PURE__ */ d(g, { children: [
  /* @__PURE__ */ s(i, { id: "reason", label: "Reason", required: !0, values: e }),
  !r && /* @__PURE__ */ s(
    p,
    {
      id: "source",
      label: "Source",
      verticalSpacingSmall: !0,
      helperText: "JIRA ticket number or other relevant source."
    }
  )
] });
u.initialValues = {
  ...i.initialValues({ id: "reason" }),
  source: void 0
};
u.validationSchema = {
  ...i.validationSchema({ id: "reason", required: !0 }),
  source: a.string()
};
u.submitValues = (e) => ({
  ...i.submitValues({ id: "reason" })(e),
  source: e.source || void 0
});
export {
  u as ReasonInput,
  i as SingleSelectWithOther
};
//# sourceMappingURL=index.js.map
